/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-15 10:00:27
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-06-13 10:22:33
 * @FilePath: /privacy-web/src/views/PrivacyPolicy/content.js
 */
const PRIVACYCONTENTLIST = [
  {
    label: '一、本声明适用范围',
    content: 'scrollOne',
    id: 1
  },
  {
    label: '二、我们收集的个人信息',
    content: 'scrollTwo',
    id: 2
  },
  {
    label: '三、我们如何使用您的信息',
    content: 'scrollThree',
    id: 3
  },
  {
    label: '四、我们如何使用Cookie和同类技术',
    content: 'scrollFour',
    id: 4
  },
  {
    label: '五、我们如何对外提供、委托处理、公开披露和转移您的个人信息',
    content: 'scrollFive',
    id: 5
  },
  {
    label: '六、我们如何存储您的个人信息',
    content: 'scrollSix',
    id: 6
  },
  {
    label: '七、我们如何保护您的个人信息',
    content: 'scrollSeven',
    id: 7
  },
  {
    label: '八、如何管理您的个人信息',
    content: 'scrollEight',
    id: 8
  },
  {
    label: '九、未成年人的个人信息保护',
    content: 'scrollNine',
    id: 9
  },
  {
    label: '十、本声明如何更新',
    content: 'scrollTen',
    id: 10
  },
  {
    label: '十一、如何联系我们',
    content: 'scrollEleven',
    id: 11
  },
  {
    label: '十二、名词解释',
    content: 'scrollTwelve',
    id: 12
  }
];
const CHILDPROTECTRULELIST = [
  {
    label: '一、本规则适用范围',
    content: 'scrollOne',
    id: 1
  },
  {
    label: '二、我们如何收集和使用儿童个人信息',
    content: 'scrollTwo',
    id: 2
  },
  {
    label: '三、我们如何对外提供、委托处理、公开披露和转移儿童个人信息',
    content: 'scrollThree',
    id: 3
  },
  {
    label: '四、我们如何存储儿童个人信息',
    content: 'scrollFour',
    id: 4
  },
  {
    label: '五、我们如何保护儿童个人信息',
    content: 'scrollFive',
    id: 5
  },
  {
    label: '六、如何管理儿童个人信息',
    content: 'scrollSix',
    id: 6
  },
  {
    label: '七、本规则如何更新',
    content: 'scrollSeven',
    id: 7
  },
  {
    label: '八、如何联系我们',
    content: 'scrollEight',
    id: 8
  },
];
const PRIVACYCONTENT = `
<p>
  贝壳控股有限公司及其<a target="_self" href="#/document">关联方</a>（以下统称为“贝壳集团”、“贝壳”、“我们”）非常重视您的个人信息和隐私保护，我们始终遵循合法合规、最小必要、公开透明、安全可靠原则全方位保障您的数据安全与个人隐私。我们特此制定《贝壳集团隐私声明》（以下统称为“本声明”）以便您了解我们如何收集、使用、传输、存储、提供、保护您的个人信息及您的权利如何行使。
  <br/>
  如您有任何关于贝壳个人信息保护的问题，请<a href="javaScript:void(0);" data-content="scrollEleven">联系我们</a>。
</p>
<p>
<img class="head-img" src="https://p.ke.com/v1/raw/p2/common/08e29ec0ab0610959e0318a00b20b8032801300138a68f01.png" alt="">
</p>
<p id="scrollOne">
	<h1><strong>一、本声明适用范围</strong></h1>
</p>
<p>
本声明适用于贝壳控股有限公司及其关联方通过下述途径向您提供的产品/服务：包括但不限于应用程序（包括贝壳找房、链家、贝壳租房、贝壳美家商城、贝壳美家、圣都整装等）、官方网站、小程序以及供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）等（以下统称为“贝壳旗下产品”）。
</p>
<p>
  除本声明外，贝壳旗下产品均发布了专门的隐私声明（以下统称为“产品隐私声明”），建议您在使用时仔细阅读，以帮助您更好地了解我们的产品或服务并作出适当的选择。
</p>
<p>
  如果您是儿童或儿童的监护人，建议您仔细阅读<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>，以帮助您更好地了解我们如何保护儿童的个人信息。
</p>
<p>
  <strong>
    各产品隐私声明、<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>是本声明的重要组成部分。若产品隐私声明、<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>与本声明之间存在不一致，以该产品隐私声明、<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>为准，产品隐私声明、<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>中未约定的，以本声明为准。
  </strong>
</p>
<p id="scrollTwo">
	<h1><strong>二、我们收集的个人信息</strong></h1>
</p>
<p>
  我们仅会出于本声明及各产品隐私声明所述目的，依据“合法、正当、必要”原则收集您的个人信息。下文列举说明了我们可能收集的个人信息：
</p>
<p class="icon-title">
  <h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08acadc0ab06108824188f012090012801300138cdf003.png" alt="">
    您使用我们的产品或服务时提供的个人信息
  </strong>
  </h3>
</p>
<div>
  <strong class="title">
    1、账号信息
  </strong>
  <div>
    您需要注册账号才能使用某些功能或者服务。您在注册账号时必要提供的个人信息包括个人电话号码或电子邮件地址，注册账号后会为您生成相应的账号名；您可自主选择提供的个人信息包括姓名、性别、生日，自主设置账号昵称、头像。  
  </div>
</div>
<p>
  <strong>
    请您知悉，为了提升您在使用贝壳旗下产品时的体验，我们采取了统一账号体系。即您可以通过在贝壳旗下任一产品注册贝壳账号，并凭借该账号登录访问和使用其他贝壳旗下产品。您基于注册该账号向我们提供的、和与该账号相关的上述信息由贝壳统一存储管理。除此以外，您在使用贝壳旗下产品时产生或向我们提供的其他个人信息，将分别由您所使用的贝壳旗下产品单独存储管理。
  </strong>
</p>
<div>
  <strong class="title">
    2、实现产品业务功能所需的信息
  </strong>
  <div>
  在向您提供我们的产品或服务过程中，可能需要您提供特定的个人信息来实现相关功能，如您使用客服功能时，可能需要提供您的部分账号信息（如账号名、账号昵称、头像）等进行身份核验。若您选择不提供该类信息，我们将无法为您提供上述特定的相关功能，但不会影响您使用产品或服务中的其他功能。
</div>
</div>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08a0b6c0ab0610e7321890012090012801300138e4d402.png" alt="">
    我们在您使用产品或服务过程中获取的个人信息
  </strong>
</h3>
</p>
<p>
  在您使用贝壳旗下产品时，我们会收集您的设备信息，您和贝壳旗下产品交互的日志信息，此类信息包括：
</p>
<p>
  <strong class="title">1、设备信息</strong>包括设备型号、设备操作系统类型、操作系统版本、设备设置（如地区/语言/时区/字号）等基本设备信息，MAC地址、IMEI、IDFA、Android OAID、HarmonyOS OAID、Android ID等设备标识符；
</p>
<p>
  <strong class="title">2、日志信息</strong>包括浏览、点击查看、搜索查询、收藏、看房记录、交易、售后、关注分享信息、发布信息、访问日期和时间、访问IP等。
</p>
<p>
  <strong class="title">3、其他相关信息</strong>如您使用与位置有关的服务时，我们可能会记录您的设备所在<strong>精准</strong>或模糊<strong>位置信息</strong>，这些位置信息可能通过GPS位置、WLAN接入点、蓝牙和基站等获取，我们会询问您是否启用<strong>位置权限</strong>；您也可根据我们提供的路径选择关闭上述权限，关闭后不会影响您使用产品或服务的其他功能，仅会影响与地理位置相关的功能。
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08a7b7c0ab06108f311890012090012801300138928602.png" alt="">
    通过间接方式收集的个人信息
  </strong>
  </h3>
</p>
<p>
  当您使用我们的关联方、合作方提供的功能或服务以及展示广告时，我们可能会根据功能或服务所需，从关联方、合作方处接收、使用其向我们提供经您授权的个人信息。
</p>
<p id="scrollThree">
	<h1><strong>三、我们如何使用您的信息</strong></h1>
</p>
<p>
  根据《个人信息保护法》等相关法律法规，我们仅会在具备合法基础的前提下才会收集、使用您的个人信息，<strong>即可能会基于您的明确同意、单独同意、为订立/履行您与贝壳的合同所必需、为履行贝壳的法定义务或法定职责、在合理范围内处理您自行公开的信息，为实现以下目的使用您的个人信息： </strong>
</p>
<p>
  <h3>（一）为您注册、生成、展示账号信息，以便您可以体验更丰富的产品功能</h3>
</p>
<p>
  <h3>（二）为您提供产品功能、服务</h3>
</p>
<p>
  如为向您提供交易撮合、信息推介等服务，我们可能会使用收集的信息用于完成您所指示的事项，例如完成某项交易、或查询某项交易进度等。
</p>
<p>
  <h3>（三）个性化推荐服务</h3>
</p>
<p>
  如我们可能会使用收集的信息（如您的看房记录、浏览信息）将您感兴趣的房源、商品或服务信息展示给您。
</p>
<p>
  <h3>（四）与您沟通</h3>
</p>
<p>
  在您同意或应您主动要求，我们会与您联系、向您发送有关您可能感兴趣的产品与服务的信息、邀请您参与我们的调研问卷等；我们严格遵循法律法规要求，不频繁通过短信、电话、邮件等对您打扰。
</p>
<p>
  <h3>（五）运营与安全保障</h3>
</p>
<p>
  我们致力于为您提供安全、可信的产品与使用环境，提供优质、高效、可靠的服务与信息是我们的核心目标。我们可能会将您的信息用于身份验证、安全防范、防止欺诈等。
</p>
<p>
  <h3>（六）统计分析</h3>
</p>
<p>
  我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息<strong>（这些统计信息不包含您的任何身份识别信息）</strong>，以便开展某些旨在提升我们产品和服务质量、进行行业研究的统计分析。
</p>
<p>
  <h3>（七）履行法定的义务或职责</h3>
</p>
<p class="mb-20">
  如在您使用产品的特定功能或服务时（例如：完成房产交易），根据相关法律法规，可能需要实名认证，因此您需要向我们提供您的<strong>真实身份信息</strong>（真实姓名、<strong>证件信息（如身份证件号码或身份证照片）</strong>）以完成实名验证。<strong>证件信息</strong>属于敏感个人信息，您可以拒绝提供，但您将可能无法获得相关服务。
</p>
<p class="mt-20">
  <strong>
    当我们需要收集您的个人信息用于本声明未载明的其它用途时，或将基于特定目的收集而来的信息用于其他目的时，会重新向您告知并取得相应合法基础，如通过主动勾选的形式事先征求您的同意。
  </strong>
</p>
<p id="scrollFour">
	<h1><strong>四、我们如何使用 Cookie 和同类技术</strong></h1>
</p>
<p>
  <h3><strong>
    （一）什么是Cookie
  </strong>
  </h3>
</p>
<p class="mb-20">
  Cookie，是一种可以让网站服务器将数据存储于用户本地终端或从用户本地终端中读取数据的中立技术。
</p>
<p class="mt-20">
  Cookie文件，是存储于网站中的小型文本文件，其内容是与用户访问网站有关的信息（例如用户名、密码、注册账号、手机号等），且通常经过加密处理。
</p>
<p>
  <h3><strong>
    （二）Cookie的使用
  </strong>
  </h3>
</p>
<p class="mb-20">
  为实现您联机体验的个性化需求，使您获得更轻松的访问体验，我们会在您的计算机或移动设备上发送一个或多个Cookie，指定给您的Cookie是唯一的，它只能被将Cookie发布给您的域中的Web服务器读取。
</p>
<p class="mt-20">
  <strong>我们承诺，我们不会将Cookie用于本声明所述目的之外的任何用途。</strong>我们使用Cookie主要为了实现以下功能或服务：简化您重复登录的步骤；存储您的偏好或您的浏览历史等数据进而为您提供偏好设置；帮助您优化对广告的选择与互动；帮助判断您的登录状态以及账户或数据安全；帮助我们改进服务效率，提升登录和响应速度；避免不必要的服务器负载，提高服务效率，节省资源、能源。
</p>
<p>
  <h3><strong>
    （三）Cookie的管理
  </strong></h3>
</p>
<p class="mb-20">
  大多数浏览器均为用户提供了管理Cookie的功能，您可根据自己的偏好管理或删除 Cookie。
</p>
<p class="mt-20">
  您可以清除计算机上保存的所有 Cookie，大部分网络浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；另外，您也可以清除软件内保存的所有Cookie。但如果您这么做，您可能需要在每一次访问贝壳集团的网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
</p>
<p>
  <h3><strong>
    （四）网络Beacon和同类技术的使用
  </strong></h3>
</p>
<p class="mb-20">
  除 Cookie 外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素" GIF 文件或 "网络 beacon"）。我们使用网络beacon的方式有：
</p>
<p class="mt-20">
  1、通过在贝壳网站使用网络beacon，计算用户访问数量，并通过访问 cookie 辨认注册的贝壳用户。<br />
  2、通过得到的cookie信息，为您提供个性化服务。
</p>
<p id="scrollFive">
	<h1><strong>五、我们如何对外提供、委托处理、公开披露和转移您的个人信息</strong></h1>
</p>
<p>
  <h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/089fbec0ab0610fd3c18900120900128013001389eca02.png" alt="">
    对外提供您的个人信息
  </strong>
</h3>
</p>
<p class="mb-20">
  <strong>
    在您使用贝壳旗下产品时，除下述及产品隐私声明提到的为完成交易所必需、保证向您服务所必需以及法律要求外，我们不会向第三方出租、出售或提供您的个人信息。当我们对外提供您的信息时，我们会事先向您告知接收您个人信息的公司、组织或个人的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并满足相应合法基础。
  </strong>
</p>
<p class="mt-20">
  <strong>
    对我们提供个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息。在敏感个人信息使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户个人信息。
  </strong>
</p>
<p>
  <strong>1、法定情形下的对外提供：</strong>我们可能会根据法律法规规定，或按行政机关、司法机关等依法提出的要求，对外提供您的个人信息。
</p>
<p>
  <strong>
    2、在满足法律和行政法规要求的情况下，向关联方提供个人信息。如贝壳找房应用向关联的第三方支付机构提供您的个人交易信息、个人信用信息，以协助您实现在线交易支付所必须的身份核验目的；向关联的第三方支付机构提供您在贝壳平台的钱包账户信息，以协助您实现理赔、提现的目的。
  </strong>
</p>
<p>
  <strong>3、在满足法律和行政法规要求的情况下，我们可能会向合作伙伴提供您的订单信息、账号信息、设备信息等，以保障为您提供的服务顺利完成。</strong>我们的合作伙伴类型包括贝壳平台服务提供者指定的品牌特许加盟商、合作平台、商品或技术服务供应商、第三方商家、第三方金融服务公司、广告、分析服务类授权合作伙伴、第三方征信机构等。
</p>
<p>
  <strong>
    例如为促进您拟租售房源快速成交，我们为您提供ACN协同作业服务：即会将您拟租售的房源信息、价格信息、带看记录以及您的联系方式提供给ACN协同合作机构、关联方及其经纪人，以共同为您提供高效的房屋出售、出租服务；如果您求租/求购房源，我们会将您的求租/求购要求、您的房源意向及偏好（基于大数据分析）、带看记录以及您的联系方式提供给ACN协同合作机构、关联方及其经纪人，以共同为您提供高效、精准的房源购置、租赁服务。
  </strong>
</p>
<p>
  <h3>
  <strong>
   <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08a2bfc0ab0610e9401890012090012801300138dce202.png" alt="">
    委托处理您的个人信息
  </strong>
</h3>
</p>
<p>
  <strong>为了向您提供更完善、优质的产品和服务，我们可能会委托合作方处理您的某些个人信息。</strong>对我们委托处理您个人信息的公司、组织和个人，我们会与其签署严格的保密协议，明确个人信息处理事项、处理期限、处理性质、处理目的以及双方责任等。<strong>我们将要求合作方仅按照我们的要求、本政策的规定以及其他任何相关的保密和安全措施来处理您的个人信息，并对合作方的个人信息处理活动进行监督。</strong>
</p>
<p>
  <h3>
  <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08e9bfc0ab061097381890012090012801300138eec403.png" alt="">
  <strong>
    公开披露您的个人信息
  </strong>
</h3>
</p>
<p>
  除本声明所明确述明的情况以外，我们不会将您的个人信息公开披露给任何公司、组织和个人。<strong>如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感个人信息，并满足相应合法基础。</strong>
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/0881c1c0ab0610a44018900120900128013001389b22.png" alt="">
    转移您的个人信息
  </strong>
  </h3>
</p>
<p>
  随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向新的公司、组织转移您的个人信息时，<strong>我们将通过推送通知、公告等形式告知您该公司、组织的名称或者姓名和联系方式，并按照法律法规及不低于本隐私声明所要求的标准继续保护或要求其继续保护您的个人信息，否则我们将要求该公司、组织重新向您告知并满足相应合法基础。</strong>
</p>
<p id="scrollSix">
	<h1><strong>六、我们如何存储您的个人信息</strong></h1>
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08a0c2c0ab06109d371890012090012801300138b334.png" alt="">
    存储地点
  </strong>
  </h3>
</p>
<p>
  <strong>您的个人信息将会被存储于中华人民共和国境内。通常情况下，我们不会将上述信息向境外传输。</strong>若存在本隐私声明所述的个人信息出境场景，或基于必要的业务需要确需将您的个人信息传输至境外，我们将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及您向境外接收方行使个人信息主体权利的方式和程序等事项，并满足相应合法基础，如取得您的单独同意；同时我们将采取必要措施，保障境外接收方处理个人信息的活动达到中国法律规定的个人信息保护标准。
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08b3c5c0ab061094311890012090012801300138ad39.png" alt="">
    存储期限
  </strong>
  </h3>
</p>
<p>
  我们只会在达成本声明所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。具体而言，我们判断个人信息的存储期限主要依据以下标准：
  <p class="mb-20 mt-20">
    1、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
  </p>
  <p class="mb-20 mt-20">
    2、保证我们为您提供服务的安全和质量；
  </p>
  <p class="mb-20 mt-20">
    3、您不同意更长的留存期间；
  </p>
  <p class="mb-20 mt-20">
    4、您注销了贝壳账号。我们将在您提出注销贝壳账号申请的15个工作日内完成对您的账号注销审核。
  </p>
  <p class="mb-20 mt-20">
    5、法律、行政法规等规定的保存期限已届满；例如《民法典》规定“向人民法院请求保护民事权利的诉讼时效期间为三年”；《房地产经纪管理办法》要求房地产经纪服务合同的保存期限不少于五年。
  </p>
  <p>
  满足上述条件，我们会根据适用法律的要求删除或匿名化处理您的个人信息。如果满足上述条件1-4，但法律、行政法规规定的保存期限未届满，我们将停止除存储和采取必要的安全保护措施之外的处理。
  </p>
</p>
<p id="scrollSeven">
	<h1><strong>七、我们如何保护您的个人信息</strong></h1>
</p>
<p>
  我们始终重视您的个人信息安全，并采取一切必要可行的措施保护您的个人信息。
</p>
<p>
<h3>
  <strong>
    （一）我们严格遵守个人信息相关法律法规
  </strong>
  </h3>
</p>
<p>
  贝壳严格遵守个人信息保护相关法律法规，确保个人信息处理活动符合法律、行政法规或依法可适用的其他制度要求。
</p>
<p>
<h3>
  <strong>
    （二）我们具备健全的数据安全管理制度
  </strong>
  </h3>
</p>
<p>
  贝壳建立了专门的个人信息安全部门，并发布了《数据安全管理制度》和《个人信息保护指引》，通过制度规范贝壳各部门的个人信息处理行为。
</p>
<p>
  贝壳及其员工始终重视数据安全意识。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并要求其遵守保密义务。此外，我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
</p>
<p>
<h3>
  <strong>
    （三）我们采取充分的数据安全技术措施
  </strong>
  </h3>
</p>
<p>
  <strong>贝壳采取业界成熟的安全技术措施来防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失，</strong>包括但不限于：
</p>
<p class="mb-20">
  1、贝壳采取加密技术对用户个人信息进行传输、保存和备份，并通过隔离技术进行隔离，确保个人信息的保密性和完整性。
</p>
<p class="mt-20 mb-20">
  2、贝壳采取严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
</p>
<p class="mt-20 mb-20">
  3、贝壳采取数据访问日志分析技术进行个人信息安全审计，确保对个人信息访问及使用行为的安全可靠。
</p>
<p class="mt-20 mb-20">
  4、我们通过去标识化等方式对个人信息进行脱敏。当我们为实现产品功能或向您提供约定的服务而需要展示您的个人信息时，我们会采用包括内容替换、去标识化处理等方式对您的信息进行脱敏，以保护您的信息安全。 
</p>
<p>
<h3>
  <strong>
    （四）我们建立了个人信息安全事件应急处置机制
  </strong>
  </h3>
</p>
<p>
  <strong>为应对个人信息泄露、损毁和丢失的风险，贝壳制定了多项制度并成立了应急响应团队。</strong>我们按照个人信息安全事件的处置规范，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
</p>
<p>
  在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
</p>
<p>
<h3>
  <strong>
    （五）我们在数据安全领域获得了权威机构的认证
  </strong>
  </h3>
</p>
<p>
  目前，我们存储您个人信息的系统已通过公安部安全等级保护三级测评。同时我们也是国内首家获得ISO信息安全及隐私安全管理体系双重认证的居住服务平台。
</p>
<p>
<h3>
  <strong>
    （六）我们就数据安全问题向您提示
  </strong>
  </h3>
</p>
<p>
  <strong>请您理解，尽管通过互联网传输信息并不完全安全，但我们将尽力确保您发送给我们的信息的安全性。我们建议您使用电子邮件、即时通讯、社交软件等交流工具时使用复杂密码，并注意保护您的个人信息安全。</strong>如果我们的物理、技术、或管理防护设施遭到破坏，信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
</p>
<p>
  <strong>
    一旦您离开贝壳，浏览或使用第三方提供的其他产品或服务，我们将没有能力和直接义务保护您向第三方提交的任何个人信息，无论您登录、浏览或使用上述产品或服务是否基于贝壳的链接或引导。但我们会提示您注意将进入第三方产品或服务，以便您更好地保护您的个人信息。
  </strong>
</p>
<p>
  如果您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即<a href="javascript:void(0);" data-content="scrollEleven">联系我们</a>，以便我们采取相应措施，禁止私自尝试或验证弱点。
</p>
<p id="scrollEight">
	<h1><strong>八、如何管理您的个人信息</strong></h1>
</p>
<p>
  贝壳非常重视您对个人信息的管理，并尽全力保障您对您个人信息的查阅、复制、更正、删除以及撤回同意等的权利。
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08e3c7c0ab06108738189001209001280130013898d001.png" alt="">
    如何查阅、复制、更正、删除您的个人信息
  </strong>
  </h3>
</p>
<p class="mb-20">
  1、 在您使用我们的产品或服务过程中，您有权查阅、复制、更正、删除您的个人信息，您可以在具体产品中的个人信息控制界面（例如：“我的”、“编辑资料”等）查阅、更正、删除您提供给贝壳的账号信息、联系方式等个人信息；您也可以通过具体产品内的设计，查阅、更正、删除您的操作记录（例如：关注、评论、浏览等）等个人信息。
</p>
<p class="mb-20 mt-20">
  <strong>
    2、 请您留意，出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的实名认证信息等初始注册信息。如您需要变更您的实名认证信息，请<a href="javascript:void(0);" data-content="scrollEleven">联系我们</a>。
  </strong>
</p>
<p class="mb-20 mt-20">
 <strong> 3、 您无法查阅、复制、更正的个人信息：</strong>除上述列明的信息外，考虑到响应请求可能给您合法权益带来的风险和损害、技术可行性及实现请求成本等因素，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用部分扩展业务功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法查阅、复制和更正，但您可<a href="javascript:void(0);" data-content="scrollEleven">联系我们</a>进行删除或做匿名化处理。
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08ecc8c0ab0610b52e1890012090012801300138d7f003.png" alt="">
    如何撤回同意
  </strong>
  </h3>
</p>
<p class="mb-20 mt-20">
  当我们基于您的同意处理您的个人信息时，您有权随时撤回您的同意。但撤回同意不会影响撤回前我们基于您的同意处理您个人信息的合法性及效力，也不影响我们基于其他合法基础处理您的个人信息。
</p>
<p class="mb-20 mt-20">
  您可以根据产品隐私声明中告知的具体路径撤回同意或授权。
</p>
<p class="mb-20 mt-20">
  <strong>
    请您留意：我们产品或服务中一部分特定业务功能将需要您的相关信息才能实现，当您撤回同意或授权后，我们可能无法为您继续提供撤回同意或授权所对应的功能，也不再处理您相应的个人信息。例如，如果您撤回对于相机权限的同意，您将无法在我们产品或服务中直接使用相机。
  </strong>
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08ced3c0ab0610cd361890012090012801300138f8e003.png" alt="">
    如何注销账户
  </strong>
  </h3>
</p>
<p>
  请您知悉并理解，注销账号的行为是不可逆的行为。在您注销账户时，我们将停止使用、删除或匿名化处理您的个人信息。<strong>由于贝壳系各关联产品间使用统一账号体系，注销之后，本账号在贝壳系下所有的产品数据将无法找回，包含贝壳找房、链家、贝壳租房、贝壳美家商城、被窝家装、圣都整装、设牛AI、贝壳团装Lite、贝壳家庭服务App（如有）和/或小程序（如有）。如有需要，请提前复制前述产品相关个人信息以防丢失。</strong>
</p>
<p>
  <strong>
    请您留意，在您注销账号后，可能面临以下风险及问题：
  </strong>
</p>
<p>
  （1）账号在贝壳系统中尚有资产或虚拟权益（包括但不限于账户余额、虚拟货币、优惠券等）且您在申请账号注销前未予处理的，相关记录可能被删除且无法恢复。因此，我们建议您在申请注销账号前，妥当处理您的账号在贝壳系统中的资产或虚拟权益，例如将账户余额提现至银行卡等。
</p>
<p>
  （2）账号内未完成的订单、服务会因您账号注销而无法继续执行，如您已完成支付义务，已支付的权益有可能无法返还。因此，我们建议您在申请注销账号前，确认账号内是否仍然存在未完成的订单、服务（特别是那些已完成支付义务但尚未最终交付的订单、服务）。
</p>
<p>
  （3）如您的账号因违法违规操作或侵犯他人合法权益导致处罚或纠纷，或者我们为履行反洗钱等法律义务，我们将在法律允许的必要的期限内保留处理此处罚、纠纷或投诉所必要的信息，以及履行反洗钱等法律义务所必要的信息，并在该等期限届满后对相关个人信息进行删除或匿名化处理。
</p>
<p>
<h3>
  <strong>
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/0885d5c0ab0610e02a1890012090012801300138b1c102.png" alt="">
    响应您的请求
  </strong>
  </h3>
</p>
<p>
  1、	如果您无法通过上述方式查阅、复制、更正或删除您的个人信息、撤回同意、注销账号，或您认为您的个人信息权利可能受到侵害，或您发现侵害个人信息权利的其他线索，您可以直接<a href="javascript:void(0);" data-content="scrollEleven">联系我们</a>。
</p>
<p>
  2、	在您行使上述权利时，出于安全性考虑，我们可能需要您提供书面请求，或配合身份验证，我们将在收到您反馈并验证您的身份后的15个工作日内答复您的请求。
</p>
<p>
  <strong>
    3、	请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。在以下情形中，基于法律法规要求，我们可能无法响应您的请求：
  </strong>
</p>
<p>
<ul>
  <li>与国家安全、国防安全直接相关的；</li>
  <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
  <li>与犯罪侦查、起诉、审判和执行判决等直接相关的；</li>
  <li>有充分证据表明您存在主观恶意或滥用权利的；</li>
  <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
  <li>涉及商业秘密的；</li>
  <li>无端重复的请求；</li>
  <li>给他人合法权益带来风险的请求。</li>
</ul>
</p>
<p>
<h3>
  <strong class="img-title" style="letter-spacing: -0.02em;">
    <img class="icon" src="https://p.ke.com/v1/raw/p2/common/08b088c1ab0610d2381890012090012801300138b0c502.png" alt="" style="margin-right: calc(10px + 0.4em);">
    如果我们终止服务或运营，我们会立即停止对您个人信息的收集，并将至少提前三十日以推送通知、公告等形式通知您，在终止服务或运营后的合理期限内删除或匿名化处理您的个人信息。
  </strong>
  </h3>
</p>
<p id="scrollNine">
	<h1><strong>九、未成年人的个人信息保护</strong></h1>
</p>
<p>
  （一）原则上，我们的产品和服务不直接面向未成年人。但我们仍非常重视对未成年人个人信息的保护，将根据国家相关法律法规的规定保护未成年人的个人信息。
</p>
<p>
  （二）若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您父母或其他监护人（统称“监护人”）的同意。监护人也应采取适当的预防措施来保护未成年人，包括监督其对我们的产品与/或服务的使用。
</p>
<p>
  （三）如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。
</p>
<p>
  <strong>（四）特别地，如果您是儿童，在使用我们的产品与/或服务前，请务必通知您的监护人一起仔细阅读贝壳专门制定的<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>，并按照注册、使用流程，事先取得您监护人的同意，</strong>并由您的监护人帮助您完成产品或服务注册流程，以便您能使用我们提供的产品或服务。
</p>
<p>
  <strong>若您是儿童的监护人，请您在您监护的儿童使用我们产品与/或服务之前，仔细阅读本声明、产品隐私声明以及<a target="_self" href="#/child-protect-rule">《贝壳儿童个人信息保护规则》</a>。</strong>在完整了解可能涉及的儿童个人信息处理情况后，作出是否同意的决定，并在同意的情形下帮助儿童进行注册，以便儿童能够使用我们提供的产品与/或服务。
</p>
<p>
  如您对您所监护的儿童个人信息保护有任何疑问或权利请求时，可以与<a href="javascript:void(0);" data-content="scrollEleven">我们联系</a>。
</p>
<p id="scrollTen">
	<h1><strong>十、本声明如何更新</strong></h1>
</p>
<p class="mb-20">
  （一）为给您提供更好的服务以及随着贝壳业务的发展，本声明也会随之更新。<strong>但未经您明确同意，我们不会削减您依据本声明所应享有的权利。</strong>
</p>
<p class="mb-20 mt-20">
  本声明更新后，我们将在贝壳隐私官网（https://privacy.ke.com/）发出更新版本并通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问贝壳隐私官网以便及时了解最新的隐私声明。
</p>
<p class="mb-20 mt-20">
  （二）对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于浏览页面做特别提示等方式，说明本声明的具体变更内容）。
</p>
<p class="mb-20">
  <strong>
    本声明所指的重大变更包括但不限于：
  </strong>
</p>
<p class="mt-20">
  <strong class="lh-2">
    1、我们的服务模式发生变更。如处理的个人信息种类、个人信息的处理目的、处理方式等变更；<br/>
    2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br/>
    3、个人信息对外提供、公开披露和转移的主要对象、处理目的、方式、个人信息种类发生变化；<br/>
    4、个人信息主体权利及其行使方式发生重大变化；<br/>
    5、我们负责处理个人信息保护的责任部门、联络方式、投诉渠道，以及外部纠纷解决机构发生变化时；<br/>
    6、个人信息保护影响评估报告表明存在高风险时；<br/>
    7、其他可能对您的个人信息权利产生重大影响的变化。
  </strong>
</p>
<p id="scrollEleven">
	<h1><strong>十一、如何联系我们</strong></h1>
</p>
<p>
  （一）如您对本声明或您个人信息的相关事宜有任何问题、意见或建议，请通过<a target="_self" href="https://privacy.ke.com/#/privacy-attestation">填写问卷</a>、发送邮件至kefu@ke.com或拨打我们的客服电话（010-10106188）等多种方式与我们联系。
</p>
<p>
  （二）我们设立了个人信息保护负责人，就您的个人信息保护相关问题，您可以通过发送邮件至gerenxinxibaohu@ke.com的方式与其联系。
</p>
<p>
  （三）一般情况下，我们将在十五工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及市场监督管理等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。
</p>
<p id="scrollTwelve">
	<h1><strong>十二、	名词解释</strong></h1>
</p>
<p>
  <strong class="title">1、 个人信息</strong>是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
</p>
<p>
  <strong  class="title">
    2、 敏感个人信息
  </strong>
  <strong>
    是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。我们在本声明中已对具体敏感个人信息以粗体进行显著标识。
  </strong>
</p>
<p>
  <strong class="title">3、儿童</strong>是指不满十四周岁的未成年人。
</p>
<p>
  <strong class="title">4、关联方</strong>就任何一方而言，系指直接或间接拥有或控制该特定一方、或被该特定一方拥有或控制、或与该特定一方处于同一控制之下的任何其他主体。在本定义中，对任何一个主体的控制（包括控制、被控制和处于同一控制之下等相关含义）系指通过合同安排或任何其他方式直接或间接地拥有选举该等主体的至少半数董事或代表的权力或拥有该等实体至少50%的表决权。贝壳控股有限公司的关联方请点击<a target="_self" href="#/document">本清单</a>查阅。
</p>
<p>
  <strong class="title">5、ACN协同作业</strong>是指贝壳指定合作范围内的合作机构（如其指定品牌特许加盟商）、关联方（链家网）之间通过共享房源、客源信息，提高经纪服务效率和准确度的一种作业方式。
</p>
<p>
  <strong class="title">6、链家网</strong>是指链家（域名：lianjia.com）及链家移动客户端、H5页面、小程序等互联网端口。
</p>
`;
const CHILDPROTECTRULE = `
<p>
  贝壳控股有限公司及其<a target="_self" href="#/document">关联方</a>（以下统称为“贝壳集团”、“贝壳”或“我们”）非常重视儿童的个人信息和隐私保护，将对儿童个人信息和隐私给予特别保护。我们特此制定《贝壳儿童个人信息保护规则》（以下统称为“本规则”）旨在向监护人（以下简称“您”）和儿童（未满14周岁的未成年人）说明我们如何收集、使用、传输、存储、提供、保护儿童的个人信息，以及您和儿童如何行使权利。
</p>
<p>
  <strong>
    【特别提示】
  </strong>
</p>
<p>
  <strong>
    若你是儿童，在使用贝壳的产品或服务前，应当仔细阅读本规则，并按照注册、使用流程，事先取得监护人的同意，并由监护人帮助你完成产品或服务注册流程，以便你能使用我们提供的产品或服务。
  </strong>
</p>
<p>
  <strong>
    若你是儿童的监护人，应当在您监护的儿童使用我们产品或服务之前，仔细阅读本规则、产品隐私声明（若有）以及<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>，在完整了解可能涉及的儿童个人信息处理情况后，作出是否同意的决定，并在同意的情形下帮助儿童进行注册，以便儿童能够使用我们提供的产品或服务。对于经您同意而收集的儿童个人信息，我们只会在法律允许、监护人明确同意或者保护儿童所必要的情况下处理此信息。
  </strong>
</p>
<p>
  <strong>
    我们希望与您共同保护儿童的个人信息安全，教育引导儿童增强个人信息保护意识和能力。
  </strong>
</p>
<p>
  <strong>
    请您仔细阅读本声明全部条款，尤其是以加粗方式显著标识的内容。如您对您所监护的儿童个人信息保护有任何疑问或权利请求时，可以与<a href="javascript:void(0);" data-content="scrollEight">我们联系</a>。
  </strong>
</p>
<p id="scrollOne">
	<strong>一、本规则适用范围</strong>
</p>
<p>
  本规则仅适用于我们在中华人民共和国境内能够识别用户为儿童的产品和服务，针对无法识别用户年龄、用户年龄必须满14周岁的产品或服务，适用<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>或产品隐私声明（若有）。
</p>
<p>
  我们的产品或服务是指贝壳合法拥有并运营的产品、服务、应用程序（包括贝壳找房、链家、贝壳租房、贝壳美家商城、贝壳美家、圣都整装等）、官方网站、小程序以及供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）等（以下统称为“贝壳旗下产品”）。
</p>
<p>
  <strong>
    本规则是<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>、产品隐私声明（若有）的重要组成部分。若本规则与<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>、产品隐私声明（若有）之间存在不一致，以本规则为准，本规则未规定的事项（如我们如何使用Cookie和同类技术、我们如何保护您的个人信息、名词解释等），以<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>或产品隐私声明（若有）为准。
  </strong>
</p>
<p id="scrollTwo">
	<strong>二、我们如何收集和使用儿童个人信息</strong>
</p>
<p>
  我们仅会出于本规则、各产品隐私声明及<a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>所述目的，依据“合法、正当、必要”原则收集儿童个人信息。
</p>
<p>
  <strong>
    实名认证
  </strong>
</p>
<p>
  如果儿童参与交易、租赁等服务时，为遵守法律法规的要求，我们需要收集儿童的<strong>身份信息（线上实名认证所必要的个人信息为证件类型、国籍、姓名、证件号（如身份证号）；您也可以选择“图片拍摄认证”，则所必要的个人信息为证件类型及证件照片，如身份证；线下实名认证所必要的个人信息包括姓名、证件号、证件照片，如果您提供的是护照或港澳台来往大陆通行证，则还需要额外提供银行卡开户证明。具体请以实名认证界面或线下认证所需个人信息为准。），以完成交易主体的身份实名认证。</strong>
</p>
<p>
  <strong>
    完成交易服务
  </strong>
</p>
<p>
  如果交易服务中的房屋所有权人中包含儿童时，为了达成服务目的，我们需要收集的必要个人信息为<strong>房屋产权证明（如：房屋所有权证）</strong>，其中可能包含儿童的个人信息；<strong>您作为儿童监护人，</strong>还需您配合提供<strong>您的身份信息（如：身份证、户口本），</strong>以验证您作为儿童监护人的身份；如果儿童与您不在同一户口本上，还需您提供<strong>盖有相关单位公章的《亲属关系证明》/医学出生证明等监护关系证明。</strong>
</p>
<p>
  <strong>
    其他
  </strong>
</p>
<p>
  在您和您监护的儿童使用贝壳旗下产品过程中，我们还可能会收集和使用其他儿童个人信息，有关具体的处理目的、方式和范围，请查阅<strong><a target="_self" href="#/privacy-policy">《贝壳集团隐私声明》</a>、产品隐私声明（若有）。</strong>
</p>
<p>
  <strong>
    监护人可以选择是否向我们提供特定的儿童个人信息。请您理解，如果您选择不提供特定信息，我们将无法为儿童提供上述特定的相关功能，但不会影响儿童使用产品或服务中的其他功能。
  </strong>
</p>
<p>
  <strong>
    如果我们需要超出以上列明的情形收集儿童的其他个人信息，我们将重新向您告知并取得相应合法基础。
  </strong>
</p>
<p id="scrollThree">
	<strong>三、我们如何对外提供、委托处理、公开披露和转移儿童个人信息</strong>
</p>
<p>
  我们严格遵守法律法规的规定，限制对外提供、委托处理、公开披露、转移、跨境传输儿童个人信息的情形。
</p>
<p>
  <strong>
    （一）对外提供儿童个人信息
  </strong>
</p>
<p>
  当我们对外提供儿童个人信息时，我们会进行个人信息保护影响评估，并会与我们提供儿童个人信息的公司、组织和个人签署严格的保密协议，要求他们按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息，如要求第三方采用数据脱敏和加密技术。
</p>
<p>
  <strong>
    （二）委托处理儿童个人信息
  </strong>
</p>
<p>
  <strong>为了向您提供更完善、优质的产品和服务，我们可能委托关联公司或合作方处理儿童的某些个人信息，在该场景下由我们向您承担相应的法律责任。</strong>对我们委托处理儿童个人信息的公司、组织和个人，我们会与其签署严格的保密协议，明确个人信息处理事项、处理期限、处理性质、处理目的以及双方责任等。<strong>我们将要求合作方按照我们的要求、本规则的规定以及其他任何相关的保密和安全措施来处理儿童个人信息，并对合作方的个人信息处理活动进行监督。</strong>
</p>
<p>
  <strong>
    （三）公开披露和转移儿童个人信息
  </strong>
</p>
<p>
  通常情况下，我们不会公开披露和转移儿童个人信息给任何公司、组织和个人。
</p>
<p>
  <strong>其他更多信息请查阅</strong><a target="_self" href="#/privacy-policy?content=（三）公开披露您的个人信息">《贝壳集团隐私声明》相应部分</a>和产品隐私声明（如有）相应部分。
</p>
<p id="scrollFour">
	<strong>四、我们如何存储儿童信息</strong>
</p>
<p>
  <strong>目前，儿童个人信息将会被存储于中华人民共和国境内。通常情况下，我们不会将儿童个人信息传输至境外。</strong>但是，若未来在您或您监护的儿童使用我们的服务过程中，为了完成您的指示或满足您的使用需求，确需将儿童个人信息传输至境外，<strong>我们将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及您向境外接收方行使儿童监护人权利的方式和程序等事项，并满足相应合法基础，如取得您的单独同意；</strong>同时我们将采取必要措施，保障境外接收方处理个人信息的活动达到中国法律规定的个人信息保护标准。
</p>
<p>
  我们将在实现儿童个人信息处理目的所必要的最短时间内保存儿童个人信息，但您或您监护的儿童行使删除权、注销账号或法律法规另有规定的除外。超出上述存储期限后，我们将删除或匿名化处理儿童个人信息。
</p>
<p id="scrollFive">
	<strong>五、我们如何保护儿童个人信息</strong>
</p>
<p>
  我们严格依照法律法规和<a target="_self" href="#/privacy-policy?content=七、我们如何保护您的个人信息">《贝壳集团隐私声明》</a>声明的保护措施保护儿童个人信息。除此之外，我们还采取了以下保护措施： 
</p>
<p>
  <strong>
    （一）数据安全管理制度
  </strong>
</p>
<p>
  为了保障儿童个人信息安全，贝壳建立了相应的管理制度、流程和组织。例如，我们会记录包含儿童个人信息在内的敏感个人信息的访问和操作，定期监测异常活动，并进行安全审计。
</p>
<p>
  <strong>
    （二）数据安全技术措施
  </strong>
</p>
<p>
  贝壳采取了业界成熟的安全技术措施来防止儿童的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失，包括但不限于：通过高强度的加密算法（如AES 256或SM3/SM4）对儿童个人信息进行加密；建立了基于角色的访问控制（RBAC），并按照业务流程需求触发操作权限，以确保只有经过授权的人员可以访问儿童的个人信息。
</p>
<p>
  <strong>
    （三）个人信息安全事件应急处置机制
  </strong>
</p>
<p>
  如果发生或可能发生儿童个人信息泄露等安全事件，我们会启动数据泄露应急处置预案，并根据实际情况采取不同的补救或止损措施，以阻止安全事件扩大。另外，我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您和您监护的儿童，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
</p>
<p id="scrollSix">
	<strong>六、如何管理儿童个人信息</strong>
</p>
<p>
  <strong>
    （一）如何查阅、复制、更正、删除儿童个人信息
  </strong>
</p>
<p>
  1.	在儿童使用我们的产品或服务过程中，您和您所监护的儿童有权查阅、复制、更正、删除其个人信息，如您和您所监护的儿童可以在具体产品中的个人信息控制界面（例如：“我的”、“编辑资料”等）查阅、更正、删除儿童提供给贝壳的账号信息、联系方式等个人信息；您也可以通过具体产品内的设计，查阅、更正、删除儿童的操作记录（例如：关注、评论、浏览等）等个人信息。
</p>
<p>
  <strong>
    2.	请您留意，出于安全性和身份识别的考虑，您和您所监护的儿童可能无法自主修改注册时提交的实名认证信息等初始注册信息。如您需要变更儿童的实名认证信息，请<a href="javascript:void(0);" data-content="scrollEight">联系我们</a>。
  </strong>
</p>
<p>
  <strong>
    3.	如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
  </strong>
</p>
<p>
  <strong>
    4.	无法查阅、复制、更正的个人信息：
  </strong>
</p>
<p>
  <strong>
    除上述列明的信息外，考虑到响应请求可能给您和您所监护的儿童合法权益带来的风险和损害、技术可行性及实现请求成本等因素，儿童的部分个人信息我们还无法提供访问和更正的服务，这些信息主要是为了提升儿童的用户体验和保证交易安全所收集的儿童的设备信息、儿童使用部分扩展业务功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您和您所监护的儿童无法查阅、复制和更正，但您和您所监护的儿童可<a href="javascript:void(0);" data-content="scrollEight">联系我们</a>进行删除或做匿名化处理。
  </strong>
</p>
<p>
  <strong>
    （二）如何撤回同意
  </strong>
</p>
<p>
  当我们基于您的同意处理儿童的个人信息时，您有权随时撤回您的同意。但撤回同意不会影响撤回前我们基于您的同意处理儿童个人信息的合法性及效力，也不影响我们基于其他合法基础处理儿童的个人信息。
</p>
<p>
  您可以根据产品隐私声明中告知的具体路径撤回同意或授权。
</p>
<p>
  <strong>
    请您留意：我们产品或服务中一部分特定业务功能将需要儿童的相关信息才能实现，当您撤回同意或授权后，我们可能无法为您所监护的儿童继续提供撤回同意或授权所对应的功能，也不再处理儿童相应的个人信息。例如，如果您撤回对于相机权限的同意，儿童将无法在我们产品或服务中直接使用相机。
  </strong>
</p>
<p>
  <strong>
    （三）如何注销账户
  </strong>
</p>
<p>
  请您知悉并理解，注销账号的行为是不可逆的行为。在您注销儿童账户时，我们将停止使用、删除或匿名化处理儿童的个人信息。<strong>鉴于贝壳采用的统一账号体系，当您通过贝壳旗下特定产品注销儿童账号时，我们将仅针对儿童通过该产品向我们提供和产生的个人信息进行删除或作匿名化处理；如您希望注销贝壳统一账号及彻底删除所有与您所监护的儿童相关的个人信息，您可以与<a href="javascript:void(0);" data-content="scrollEight">我们联系</a>，我们将协助您注销贝壳统一账号，并对有关您所监护的儿童的所有个人信息作删除或进行匿名化处理，但法律法规另有规定的除外。</strong>
</p>
<p>
  <strong>
    请您留意，在您注销账号后，可能面临相应风险及问题，具体请访问<a target="_self" href="#/privacy-policy?content=（三）如何注销账户">《贝壳集团隐私声明》相应部分</a>以了解详情。
  </strong>
</p>
<p>
  <strong>
    （四）响应您的请求
  </strong>
</p>
<p>
  1.	如果您或您所监护的儿童无法通过上述方式行使儿童个人信息主体权利，或您认为儿童个人信息权利可能受到侵害，或您发现侵害个人信息权利的其他线索，您可以与<a href="javascript:void(0);" data-content="scrollEight">我们联系</a>。
</p>
<p>
  2.	在您行使上述权利时，出于安全性考虑，我们可能需要您提供书面请求，或配合身份验证，我们将在收到您反馈并验证您的身份后的15个工作日内答复您的请求。
</p>
<p>
  <strong>
    3.	请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，具体请参见<a target="_self" href="#/privacy-policy?content=（四）响应您的请求">《贝壳集团隐私声明》相应部分</a>以了解详情。
  </strong>
</p>
<p id="scrollSeven">
	<strong>七、本规则如何更新</strong>
</p>
<p>
  1、为给您提供更好的服务以及随着贝壳业务的发展，本规则也会随之更新。<strong>但未经您明确同意，我们不会削减您和您所监护的儿童依据本规则所应享有的权利。</strong>
</p>
<p>
  本规则更新后，我们将在贝壳隐私官网（https://privacy.ke.com/）发出更新版本并通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问贝壳隐私官网以便及时了解最新的隐私声明。
</p>
<p>
  对于重大变更，我们还会提供更为显著的通知（如可能会通过浏览页面做特别提示等方式，说明隐私声明的具体变更内容）。<strong>本声明所指的重大变更，具体请参见<a target="_self" href="#/privacy-policy?content=十、本声明如何更新">《贝壳集团隐私声明》相应部分</a>以了解详情。</strong>
</p>
<p id="scrollEight">
	<strong>八、如何联系我们</strong>
</p>
<p>
  1、我们已指定专人负责儿童个人信息保护事宜，如您对本规则或对儿童个人信息的相关事宜有任何问题、意见或建议，请通过<a target="_self" href="https://privacy.ke.com/#/privacy-attestation">填写问卷</a>、发送邮件至kefu@ke.com或拨打我们的客服电话（010-10106188）等多种方式与我们联系。
</p>
<p>
  2、一般情况下，我们将在十五工作日日内回复。如果您对我们的回复不满意，特别是我们的儿童个人信息处理行为损害了您或儿童的合法权益，您还可以向网信、电信、公安及市场监督管理等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。
</p>
`;
export const documentObj = {
  'child-protect-rule': {
    list: CHILDPROTECTRULELIST,
    html: CHILDPROTECTRULE,
    title: '贝壳儿童个人信息保护规则'
  },
  'privacy-policy': {
    list: PRIVACYCONTENTLIST,
    html: PRIVACYCONTENT,
    title: '贝壳集团隐私声明'
  }
};
